import React from 'react';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <svg className="logo" width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 21.35L10.55 20.03C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3C9.24 3 10.91 3.87 12 5.06C13.09 3.87 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5C22 12.28 18.6 15.36 13.45 20.03L12 21.35Z" fill="#00ff7f"/>
      </svg>
      <h1>محاسبه‌گر BMI حرفه‌ای</h1>
      <p>سلامت خود را با یک کلیک چک کنید! <i className="fas fa-heartbeat"></i></p>
    </header>
  );
}

export default Header;